import { TFilteredContentFilters } from '@/utils/queryOptions';
import { TContentFilters } from '@/modules/content/feed/filters/model/types';

// Maps the applied filter set onto the deterministic /filtered (and /search) query. Empty
// groups are dropped so they don't send empty params.
export const filtersToQuery = (f: TContentFilters): TFilteredContentFilters => ({
  type: f.types.length ? f.types : undefined,
  domains: f.domains.length ? f.domains : undefined,
  subdomains: f.topics.length ? f.topics : undefined,
  creator: f.creator,
});
